import { EditContainer } from 'features/globalSetup/forms/Prebid/Modules/AnalyticsAdaptersForm/GeneralForm'

export const GeneralPage = (): JSX.Element => {
  return <EditContainer />
}
